import React from "react";
import { StorageUtils } from "../Utils/StorageUtils";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "../view/LandingPage";
import CreatePage from "../view/CreatePage";
import MarketingPage from "../view/MarketingPage";
import SettingsPage from "../view/SettingsPage";
import NotFoundPage from "../view/NotFoundPage";
import PrivacyPolicy from "../view/PrivacyPolicy";
import TermsAndConditions from "../view/TermsAndConditions";
import CookiePolicy from "../view/CookiePolicy";
import BookmarkPage from "../view/BookmarkPage";
import AdminMetrics from "../view/AdminMetrics";

import DashScreen from "../view/DashScreen";
import TopNavbar from "../components/UI/TopNavbar";
import SignupScreen from "../view/SignupScreen";
import ProtectedRoute from "./ProtectedRoute";
import SummaryViewer from "../view/SummaryDynamicViewerWithComments";

const AppContent = () => {
  const location = useLocation();
  const hiddenNavbarPaths = ['/sign-up', '/login', '/auth'];
  
  // Hide navbar on landing page (/) and sign-up/login paths
  const isLandingPage = location.pathname === '/';
  const shouldHideNavbar = isLandingPage || hiddenNavbarPaths.some(path => location.pathname.startsWith(path));
  
  return (
    <>
      {!shouldHideNavbar && <TopNavbar />}
      <Routes>
        <Route path="/" element={<MarketingPage />} />
        <Route
          path="/create"
          element={
            <ProtectedRoute>
              <CreatePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/extension" element={<BookmarkPage />} />

        <Route path="/auth" element={<LandingPage />} />
        <Route
          path="/demo"
          element={<MarketingPage />}
        />
        <Route path="/sign-up" element={<SignupScreen />} />
        <Route path="/summary/:slug" element={<SummaryViewer />} />
        {/* Admin route - protected and checks admin email */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminMetrics />
            </ProtectedRoute>
          }
        />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default AppRoutes;
